/*
 * @Author: yejianfei
 * @Date: 2022-05-28 15:26:23
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-17 16:23:31
 * @Description:
 * @Developer:
 */
import React, { forwardRef, useEffect } from 'react';
import { Form } from 'antd';
import { cloneDeep, merge } from 'lodash';
import Api from '../../api';
const api = Api();
export default forwardRef((props, formRef) => {
    useEffect(() => {
        if (props.value && props.loader) {
            const loader = props.loader;
            const before = props.onBeforeLoad || (() => { });
            Promise
                .resolve(before(props.value))
                .then((res) => {
                const params = Object.assign({}, (res || {}));
                params[props.idProp || 'id'] = props.value;
                return api.get(loader, { params });
            })
                .then((data) => props.onLoaded ? props.onLoaded(data) : data)
                .then((data) => {
                var _a;
                (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldsValue(data);
            });
        }
    }, [props.value]);
    const onFinish = props.onFinish || ((values) => {
        const method = values[props.idProp || 'id'] || props.value ? 'put' : 'post';
        const succeeded = props.onRequestSucceeded || (() => { });
        const failed = props.onRequestFailed || (() => { });
        const request = (method, values) => {
            const id = {};
            if (props.value) {
                id[props.idProp || 'id'] = props.value;
            }
            const payload = Object.assign(Object.assign({}, id), merge(cloneDeep(props.initialValues), cloneDeep(values)));
            if (props.action) {
                return method == 'post' ? api.post(props.action, payload) : api.put(props.action, Object.assign({}, payload));
            }
            else {
                return Promise.resolve();
            }
        };
        Promise
            .resolve((props.onBeforeRequest || ((_method, v) => v))(method, values))
            .then((v) => v !== false ? request(method, v) : Promise.resolve())
            .then((res) => succeeded(method, res, values))
            .catch((error) => failed(method, error, values));
    });
    const attributes = Object.assign(Object.assign({}, props), { onFinish });
    delete attributes.idProp;
    delete attributes.action;
    delete attributes.config;
    delete attributes.onBeforeRequest;
    delete attributes.onRequestSucceeded;
    delete attributes.onRequestFailed;
    delete attributes.onLoaded;
    delete attributes.onSucceededMessage;
    delete attributes.onFailedMessage;
    return React.createElement(Form, Object.assign({ ref: formRef }, attributes));
});
